module.exports = __webpack_public_path__ + "officialStatic/img/detail-list-bg.b000045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-list-bg.png
// module id = ElFE
// module chunks = 0